<template>
    <AdminNextIframe
        path="/cms-auto-publish"
        :query="{ clientId: $route.params.id }"
        @back="onBack" />
</template>

<script>
import AdminNextIframe from '@/components/ui/iframe/AdminNextIframe';

export default {
    name: 'ClientCmsAutoPublish',
    components: { AdminNextIframe },
    methods: {
        onBack() {
            this.$router.push({
                name: 'client',
                params: { id: this.$route.params.id }
            });
        }
    }
}
</script>
